/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { communicationAttachmentFromFile, communicationAttachmentToFile } from '@gh/builder-shared';
import { FileListItem } from '@gh/common-internal-shared';
import { createDialogRoute } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { DialogInput } from '@gh/core-ui';
import { JobOrderDetailsAttachment } from '../../../resources/job-order-list.model';

export interface JobOrderDetailsAttachmentDialogConfig {
  folderId: ID;
  attachments: JobOrderDetailsAttachment[];
}

@Component({
  selector: 'gh-order-attachment-details-dialog',
  template: require('./job-order-details-attachment-dialog.component.html'),
  styles: [require('./job-order-details-attachment-dialog.component.scss')],
})
export class JobOrderDetailsAttachmentDialogComponent implements DialogInput<JobOrderDetailsAttachmentDialogConfig>, OnInit {
  input: JobOrderDetailsAttachmentDialogConfig;

  files: FileListItem[];

  private modified = false;

  constructor(private dialogRef: MatDialogRef<any, JobOrderDetailsAttachment[]>) {

  }

  get folderId(): ID {
    return this.input.folderId;
  }

  ngOnInit(): void {
    this.files = this.input.attachments.map(communicationAttachmentToFile);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onOk(): void {
    if (this.modified) {
      this.dialogRef.close(this.files.map(communicationAttachmentFromFile));
    } else {
      this.dialogRef.close(this.input.attachments);
    }
  }

  onFilesChange(files: FileListItem[]): void {
    this.modified = true;
    this.files = files;
  }
}

export const jobOrderDetailsAttachmentDialogRoute = createDialogRoute({
  component: JobOrderDetailsAttachmentDialogComponent,
  config: {width: '400px'},
});
